import { render, staticRenderFns } from "./MonitorsHistory.vue?vue&type=template&id=e1e24d08&"
import script from "./MonitorsHistory.vue?vue&type=script&lang=js&"
export * from "./MonitorsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports